
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'glxy-none-selected-input-filter-input',
  template: ` <p>{{ 'GALAXY.FILTER.CHIP.INVALID_FILTER_TYPE' | translate }}</p> `,
  providers: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule],
})
export class GalaxyNoneSelectedFilterInputComponent {}
